import {
    createAsyncThunk
} from '@reduxjs/toolkit';
import axios from 'axios';
import {
    api
} from '../../helpers/api_helper';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';


export const getMobileListingData = createAsyncThunk(
    'mobileView/listing',
    async (info, thunkAPI) => {
        try {
            const url =  API_ENDPOINTS.MOBILE_VIEW.LISTING(info);
            const response = await api.get(url);
            // Log('getMobileListingData' , response.data)
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);